const SMOKING_POLICY = {
  YES: 'YES',
  NO: 'NO',
  OUTSIDE_ONLY: 'OUTSIDE_ONLY',
};

module.exports = SMOKING_POLICY;
